export default {
  buttons: {
    save: 'Opslaan',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
  },
  confirmation: {
    title: 'Weet u zeker dat u wilt synchroniseren met externe diensten?',
  },
};
